<dsd-container padding="none">
  <dsd-grid-row class="row-reverse">
    <dsd-grid-col sm-col="12" md-col="6">
      <div
        [ngClass]="{
          'keep-content-size': variant === 'keepContentSize',
          'keep-image-size': variant === 'keepImageSize'
        }"
      >
        <img
          class="mobile-image md:dsd-d-none"
          src="{{ imgSrc | cheminAbsoluStatique }}"
          alt=""
          [ngStyle]="{ 'object-position': imgCenter }"
        />
        <img
          class="desktop-image dsd-d-none sm:dsd-d-flex"
          src="{{ imgDesktopSrc || imgSrc | cheminAbsoluStatique }} "
          alt=""
          [ngStyle]="{ 'object-position': imgDesktopCenter || imgCenter }"
        />
      </div>
    </dsd-grid-col>
    <dsd-grid-col md-col="6">
      <dsd-container margin="none">
        <ng-content></ng-content>
      </dsd-container>
    </dsd-grid-col>
  </dsd-grid-row>
</dsd-container>
